import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import Toast from "../../components/shared/Toast";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../../components/shared/NormalButton";
import { UserContext } from "../../App";
import SelectField from "../../components/shared/SelectField";

const GoldiePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('goldie.pageTitle'));
    const navigate = useNavigate();
    const pageTitle = {title: t('goldie.title'), subTitle: t('goldie.subtitle')};
    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:''});
    const [selectedGoldiePlan, setSelectedGoldiePlan] = useState(null);
    const [subscribeForm, setSubscribeForm] = useState({field: '', subscriptionType: ''});
    const [goldiePlanId, setGoldiePlanId] = useState(null);
    const [goldiePlanTotalCost, setGoldiePlanTotalCost] = useState(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [errors, setErrors] = useState(null);
    
    const [noPlansFound, setNoPlansFound] = useState(false);

    const [fieldsOptions, setFieldsOptions] = useState(null);

    const [isActionLoading, setIsActionLoading] = useState(false);

    const [showSubscribeToGoldie, setShowSubscribeToGoldie] = useState(false);

    const {fields} = useContext(UserContext);


    useEffect(()=>{
        if(fields && vendor) {
            setFieldsOptions(fields?.filter(f=>vendor?.fields?.includes(f?.field?.code))?.map(f=>({value:f.field.code,label:f.field.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || f.field.name.ar,subFields:f?.maintenanceListPerDevice.flatMap(item => item.maintenanceList)})));
        }
    },[fields,vendor])

    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    const getGoldiePlans = async (field,subscriptionType) => {
        setNoPlansFound(false);
        try {
          const response = await apiClient.get(`/vendor-golden-star-plans/field?field=${field}&subscriptionType=${subscriptionType}`);
          if(response?.data) {
            if(response?.data?.goldenStarPlan?.isActive) {
                setSelectedGoldiePlan(response?.data?.goldenStarPlan);
                setGoldiePlanId(response?.data?.goldenStarPlan?._id);
            } else {
                setNoPlansFound(true);
                setSelectedGoldiePlan(null);
                setGoldiePlanId(null);
            }
          } else {
            setNoPlansFound(true);
            setSelectedGoldiePlan(null);
            setGoldiePlanId(null);
          }
        } catch(err) {
            setNoPlansFound(true);
            setSelectedGoldiePlan(null);
            setGoldiePlanId(null);
        }
    }

    useEffect(()=>{
        if(subscribeForm && subscribeForm?.field && subscribeForm?.subscriptionType) {
            getGoldiePlans(subscribeForm?.field,subscribeForm?.subscriptionType);
        }
    },[subscribeForm])

    useEffect(()=>{
        if(selectedGoldiePlan) {
            const totalCost = parseInt(selectedGoldiePlan.workersCountInField) * parseInt(selectedGoldiePlan?.extraTechniciansFees);
            setGoldiePlanTotalCost(totalCost);
        }
    },[selectedGoldiePlan])

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])

    // const getExtraTchCount = () => {
    //   let count;
    //   if(parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount) > 0 && parseInt(vendor?.workersCount) > parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount)) {
    //     count = parseInt(vendor?.workersCount) > parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount) ? parseInt(vendor?.workersCount) - parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount) : 0;
    //   } else {
    //     count = 0;
    //   }
    //   return count;
    // }

    // const getExtraGoldie = () => {
    //     if(getExtraTchCount() > 0) {
    //         return getExtraTchCount() * parseInt(vendor?.activeSubscription?.plan?.extraGoldStarFees[vendor?.currentGoldenStarSubscriptionType || 'MONTHLY']);
    //     } else {
    //         return 0
    //     }
    // }

    const subscribeToGoldieAction = async () => {
        setIsActionLoading(true);
        const body = {
            "planId": goldiePlanId,
            "totalCost": goldiePlanTotalCost,
            "paymentMethod": selectedPaymentMethod
            }
        try {
            const response = await apiClient.post('/vendors/me/golden-star/subscribe',body);
            if(response && (response.status === 201 || response.status === 200)) {  
                setToast({show:true,type:'success',message:t('goldie.subscribedSuccessfully')});
                navigate(`/${i18n.language}/workers`);
            } else {
                setToast({show:true,type:'error',message:t('goldie.errorTryAgain')});
            }
            setIsActionLoading(false);
        } catch (err) {
            setToast({show:true,type:'error',message:err?.response?.data?.message || t('goldie.errorTryAgain')});
            setIsActionLoading(false);
        }
    }


    const subscribeToGoldie = () => {
        setSubscribeForm({field: '', subscriptionType: ''});
        setSelectedGoldiePlan(null);
        setGoldiePlanId(null);
        setGoldiePlanTotalCost(null);
        setSelectedPaymentMethod(null);
        setNoPlansFound(false);
        setShowSubscribeToGoldie(true);
    }

    const closeModal = () => {
        setShowSubscribeToGoldie(false);
    }


    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])

    const subscriptionTypeOptions = [
        // {value:'DAILY', label: 'يومي'},
        {value:'WEEKLY', label: t('goldie.weekly')},
        // {value:'MONTHLY', label: 'شهري'},
    ];

    const paymentMethodOptions = [
        {value:'wallet', label: t('goldie.wallet')},
        {value:'stcpay', label: 'STC', disabled: true},
    ];

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(selectedPaymentMethod && goldiePlanId && goldiePlanTotalCost) {
            setIsSubmitDisabled(false);
        } else {
            setIsSubmitDisabled(true);
        }
    },[selectedPaymentMethod,goldiePlanId,goldiePlanTotalCost])


    return (<>
        <PageHeader pageTitle={pageTitle} subTitleColored={true} subTitleBold />
        <PageMain>
            <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
            {vendor && <MainContent>
                <div className="">
                    <div className="w-full p-[24px] border-[1px] border-grey-300 rounded-[24px] bg-white mx-auto mt-[32px] mb-[16px] text-center">
                        <img src="/assets/images/goldie.svg" alt="" className="block mx-auto mb-[24px]" />
                        <h2 className="text-[#F48B19] text-[24px] font-[700] leading-[36px] mb-[24px]">{t('goldie.multiplyRequests')}</h2>
                        <h3 className="text-[#212E35] font-[700] text-start text-[24px]">{t('goldie.goldieBenefits')}</h3>
                        <div className="flex flex-wrap w-full text-start gap-x-[12px] gap-y-[24px] pt-[24px]">
                            
                            <div className="text-[#0088CF] bg-[#D0F0FF] rounded-[8px] px-[12px] py-[4px] w-fit text-[20px] font-[500] lg:whitespace-nowrap">
                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[8px]">
                                    <path d="M19.5353 0.484222C18.9165 -0.161611 17.9116 -0.161204 17.292 0.484222L7.19574 11.0079L2.70838 6.3308C2.08875 5.68497 1.08435 5.68497 0.464721 6.3308C-0.154907 6.97663 -0.154907 8.02352 0.464721 8.66935L6.07367 14.5155C6.38329 14.8382 6.78928 15 7.19531 15C7.60134 15 8.00772 14.8386 8.31733 14.5155L19.5353 2.82273C20.1549 2.17735 20.1549 1.13001 19.5353 0.484222Z" fill="#0088CF"/>
                                </svg>
                                {t('goldie.priorityRouting')}
                            </div>

                            <div className="text-[#D4A33A] bg-[#FAEBCC] rounded-[8px] px-[12px] py-[4px] w-fit text-[20px] font-[500] lg:whitespace-nowrap">
                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[8px]">
                                    <path d="M19.5353 0.484222C18.9165 -0.161611 17.9116 -0.161204 17.292 0.484222L7.19574 11.0079L2.70838 6.3308C2.08875 5.68497 1.08435 5.68497 0.464721 6.3308C-0.154907 6.97663 -0.154907 8.02352 0.464721 8.66935L6.07367 14.5155C6.38329 14.8382 6.78928 15 7.19531 15C7.60134 15 8.00772 14.8386 8.31733 14.5155L19.5353 2.82273C20.1549 2.17735 20.1549 1.13001 19.5353 0.484222Z" fill="#D4A33A"/>
                                </svg>
                                {t('goldie.moreRequests')}
                            </div>

                            <div className="text-[#633693] bg-[#EEE7F5] rounded-[8px] px-[12px] py-[4px] w-fit text-[20px] font-[500] lg:whitespace-nowrap">
                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[8px]">
                                    <path d="M19.5353 0.484222C18.9165 -0.161611 17.9116 -0.161204 17.292 0.484222L7.19574 11.0079L2.70838 6.3308C2.08875 5.68497 1.08435 5.68497 0.464721 6.3308C-0.154907 6.97663 -0.154907 8.02352 0.464721 8.66935L6.07367 14.5155C6.38329 14.8382 6.78928 15 7.19531 15C7.60134 15 8.00772 14.8386 8.31733 14.5155L19.5353 2.82273C20.1549 2.17735 20.1549 1.13001 19.5353 0.484222Z" fill="#633693"/>
                                </svg>
                                {t('goldie.prioritySupport')}
                            </div>

                            <div className="text-white bg-[#212E35] rounded-[8px] px-[12px] py-[4px] w-fit text-[20px] font-[500] lg:whitespace-nowrap">
                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[8px]">
                                    <path d="M19.5353 0.484222C18.9165 -0.161611 17.9116 -0.161204 17.292 0.484222L7.19574 11.0079L2.70838 6.3308C2.08875 5.68497 1.08435 5.68497 0.464721 6.3308C-0.154907 6.97663 -0.154907 8.02352 0.464721 8.66935L6.07367 14.5155C6.38329 14.8382 6.78928 15 7.19531 15C7.60134 15 8.00772 14.8386 8.31733 14.5155L19.5353 2.82273C20.1549 2.17735 20.1549 1.13001 19.5353 0.484222Z" fill="white"/>
                                </svg>
                                {t('goldie.otherFeatures')}
                            </div>
                            
                        </div>
                    </div>
                    <div className="border-[1px] border-grey-300 rounded-[24px] p-[24px]">
                        <h2 className="leading-[36px] font-[700] text-[24px] text-grey-900">{t('goldie.subscriptionDetails')}</h2>
                        <div className="mt-[32px]">
                            {/* <div className="flex flex-nowrap mb-[18px]">
                                <div className="w-[75%] text-start font-[700] text-[14px] text-grey-900 leading-[24px]">عدد الفنيين داخل الباقة {`(${getExtraTchCount() > 0 ? parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount) : parseInt(vendor?.workersCount)}/`}<span dir="ltr">{parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount) > 0 ? parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount) : 'غير محدود'}</span>{`)`} </div> 
                                <div className="w-[25%] text-end font-[500] text-[16px] text-grey-900 leading-[24px]">
                                    {vendor?.activeSubscription?.plan?.goldStarFees['MONTHLY']}
                                    <img src="/assets/images/pack-sar.svg" alt="" className="w-[11px] inline-block align-baseline ms-[4px]" />
                                </div>
                            </div>
                            <div className="flex flex-nowrap mb-[18px]">
                                <div className="w-[75%] text-start font-[700] text-[14px] text-grey-900 leading-[24px]">عدد الفنيين خارج الباقة {`(${getExtraTchCount()})`} </div> 
                                <div className="w-[25%] text-end font-[500] text-[16px] text-grey-900 leading-[24px]">
                                    {getExtraGoldie()}
                                    <img src="/assets/images/pack-sar.svg" alt="" className="w-[11px] inline-block align-baseline ms-[4px]" />
                                </div>
                            </div>
                            <div className="flex flex-nowrap pt-[18px] pb-[18px] border-t-[1px] border-grey-200">
                                <div className="w-[75%] text-start font-[700] text-[18px] text-grey-900 leading-[36px]">إجمالي ما سيتم دفعه</div> 
                                <div className="w-[25%] text-end font-[700] text-[24px] text-grey-900 leading-[36px]">
                                    {vendor?.activeSubscription?.plan?.goldStarFees['MONTHLY'] + getExtraGoldie()}
                                    <img src="/assets/images/pack-sar.svg" alt="" className="w-[18px] inline-block align-baseline ms-[4px]" />
                                </div>
                            </div> */}
                            <div className="pt-[18px] border-t-[1px] border-grey-200 flex flex-wrap lg:flex-nowrap">
                                <div className="w-full lg:w-[50%] text-grey-900 font-[700] leading-[48px]">
                                    {t('goldie.calcBasedOnSpecialties')}
                                </div>
                                <div className="w-full lg:w-[50%] text-end">
                                    <div className={`w-full max-w-[360px] h-[48px] leading-[48px] text-center inline-block text-white bg-darkBlue rounded-[8px] text-[18px] font-[600] cursor-pointer transition-transform hover:scale-105 select-none ${isActionLoading ? 'pointer-events-none opacity-50' : ''}`} onClick={()=>subscribeToGoldie()}>{t('goldie.subscribe')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

<br />

            </MainContent>}
        </PageMain>


        { showSubscribeToGoldie && <ModalContainer maxWidth={'775px'} heading={t('goldie.goldieSubscriptionHeading')} handleCloseModal={closeModal}>
            <div className="">

                <div className="relative w-full bg-grey-50 border-[1px] border-grey-200 rounded-[16px] p-[20px] my-[24px]">

                    <div className="mb-[15px]">
                        <SelectField isRequird label={t('goldie.specialty')} placeholder={t('goldie.selectSpecialty')} options={fieldsOptions} value={subscribeForm?.field} error={errors?.field} errorMessage={errors?.field} translateError={true} onChange={(e)=>{setSubscribeForm({ ...subscribeForm, field: e.target.value }); hideError('field')}} />
                    </div>

                    <div className="mb-[15px]">
                        <SelectField isRequird label={t('goldie.subscriptionDuration')} placeholder={t('goldie.selectDuration')} options={subscriptionTypeOptions} value={subscribeForm?.subscriptionType} error={errors?.subscriptionType} errorMessage={errors?.subscriptionType} translateError={true} onChange={(e)=>{setSubscribeForm({ ...subscribeForm, subscriptionType: e.target.value }); hideError('subscriptionType')}} />
                    </div>

                    <div className="mb-[15px]">
                        <SelectField isRequird label={t('goldie.paymentMethod')} placeholder={t('goldie.selectPaymentMethod')} options={paymentMethodOptions} value={selectedPaymentMethod} error={errors?.paymentMethod} errorMessage={errors?.paymentMethod} translateError={true} onChange={(e)=>{setSelectedPaymentMethod(e.target.value); hideError('paymentMethod')}} />
                    </div>

                    {noPlansFound ? <p className="text-danger">{t('goldie.noMatchingPlans')}</p> : ''}

                    {selectedGoldiePlan && goldiePlanTotalCost ? 
                    <div className="">
                        <div className="font-[500]">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[4px]">
                                <path d="M12.947 7.8335H10.667C10.3937 7.8335 10.167 7.60683 10.167 7.3335V2.6735C10.167 2.18016 10.3603 1.72016 10.707 1.3735C11.0537 1.02683 11.5137 0.833496 12.007 0.833496H12.0137C12.847 0.840163 13.6337 1.16683 14.2337 1.76016C14.8337 2.36683 15.1603 3.16683 15.1603 4.00016V5.61349C15.167 6.94016 14.2737 7.8335 12.947 7.8335ZM11.167 6.8335H12.947C13.7203 6.8335 14.167 6.38683 14.167 5.61349V4.00016C14.167 3.42683 13.9403 2.88016 13.5337 2.46683C13.127 2.06683 12.5803 1.84016 12.0137 1.8335C12.0137 1.8335 12.0137 1.8335 12.007 1.8335C11.787 1.8335 11.5737 1.92016 11.4137 2.08016C11.2537 2.24016 11.167 2.44683 11.167 2.6735V6.8335Z" fill="#475569"/>
                                <path d="M5.99984 15.5535C5.68651 15.5535 5.39318 15.4335 5.17318 15.2068L4.06651 14.0935C4.00651 14.0335 3.91317 14.0268 3.84651 14.0802L2.70651 14.9335C2.35317 15.2002 1.88651 15.2468 1.48651 15.0468C1.08651 14.8468 0.839844 14.4468 0.839844 14.0002V4.00016C0.839844 1.98683 1.99318 0.833496 4.00651 0.833496H12.0065C12.2798 0.833496 12.5065 1.06016 12.5065 1.3335C12.5065 1.60683 12.2798 1.8335 12.0065 1.8335C11.5465 1.8335 11.1732 2.20683 11.1732 2.66683V14.0002C11.1732 14.4468 10.9265 14.8468 10.5265 15.0468C10.1265 15.2468 9.65984 15.2068 9.30651 14.9402L8.16651 14.0868C8.09984 14.0335 8.00651 14.0468 7.95318 14.1002L6.83318 15.2202C6.60651 15.4335 6.31318 15.5535 5.99984 15.5535ZM3.93984 13.0468C4.24651 13.0468 4.54651 13.1602 4.77318 13.3935L5.87984 14.5068C5.91984 14.5468 5.97318 14.5535 5.99984 14.5535C5.99318 14.5402 6.07984 14.5468 6.11984 14.5068L7.23984 13.3868C7.65318 12.9735 8.30651 12.9335 8.76651 13.2868L9.89984 14.1335C9.97318 14.1868 10.0398 14.1668 10.0732 14.1468C10.1065 14.1268 10.1665 14.0868 10.1665 14.0002V2.66683C10.1665 2.36683 10.2398 2.08016 10.3665 1.8335H3.99984C2.51984 1.8335 1.83318 2.52016 1.83318 4.00016V14.0002C1.83318 14.0935 1.89318 14.1335 1.92651 14.1535C1.96651 14.1735 2.03318 14.1868 2.09984 14.1335L3.23984 13.2802C3.44651 13.1268 3.69318 13.0468 3.93984 13.0468Z" fill="#475569"/>
                                <path d="M7.83366 7.1665H4.16699C3.89366 7.1665 3.66699 6.93984 3.66699 6.6665C3.66699 6.39317 3.89366 6.1665 4.16699 6.1665H7.83366C8.10699 6.1665 8.33366 6.39317 8.33366 6.6665C8.33366 6.93984 8.10699 7.1665 7.83366 7.1665Z" fill="#475569"/>
                            </svg>
                            {t('goldie.subscriptionAmountDetails')} {subscriptionTypeOptions?.find(o=>o.value === subscribeForm?.subscriptionType)?.label}
                        </div>
                        {(selectedGoldiePlan.workersCountInField > 0) ? <div className="mt-[12px] flex flex-nowrap">
                            <div className="w-[75%]">{t('goldie.techSubscriptionPrice')} 
                                ({selectedGoldiePlan.workersCountInField} {t('goldie.technicians')})
                            </div>
                            <div className="w-[25%] text-end font-[500] text-[16px]">
                                {(selectedGoldiePlan.workersCountInField)* selectedGoldiePlan?.extraTechniciansFees}
                                <img src="/assets/images/pack-sar.svg" alt="" className="w-[11px] inline-block align-baseline ms-[4px]" />
                            </div>
                        </div> : ''}
                        <div className="mt-[12px] flex flex-nowrap">
                            <div className="w-[75%]">{t('goldie.totalSubscriptionPrice')}
                            </div>
                            <div className="w-[25%] text-end font-[500] text-[16px]">
                                {goldiePlanTotalCost}
                                <img src="/assets/images/pack-sar.svg" alt="" className="w-[11px] inline-block align-baseline ms-[4px]" />
                            </div>
                        </div>

                    </div> : ''}
                    {selectedGoldiePlan && goldiePlanTotalCost === 0 && selectedGoldiePlan.workersCountInField === 0 ?
                    <div className="text-danger">{t('goldie.noTechsInField')}</div>
                    :''}

                </div>
               <br />
                <div className="w-full text-end">
                    <NormalButton label={t('goldie.subscribe')} isDisabled={isSubmitDisabled} onClick={subscribeToGoldieAction} />
                </div>
            </div>
        </ModalContainer> }


        <Toast toast={toast} setToast={setToast} />
        {(!vendor || isActionLoading) && <Loading showLoading={true} />}
    </>)
}

export default GoldiePage;